import firebase from 'firebase/app';

export const isNotificationSupported = () => {
  return (
    'Notification' in window &&
    'serviceWorker' in navigator &&
    (firebase?.messaging?.isSupported() || false)
  );
};

export const getNotificationPermission = () => {
  if (!isNotificationSupported()) {
    return null;
  }
  return window.Notification.permission;
};
